import axios from 'axios';

// Backend temporário para testes (Cloudflare Worker)
// Futuro: substituir por https://api.gasnaporta.com.br/api
const BACKEND_URL = 'https://gasnaporta-backend.atendimento-popular-gas.workers.dev/api';
const baseURL = BACKEND_URL;

const api = axios.create({ baseURL });

api.interceptors.request.use(cfg => {
  const token = localStorage.getItem('token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

export default api;